<div class="table-fms" data-qa="ma-by-industry-dilution-table">
  <table>
    <thead>
      <tr>
        <th class="fix-w-10p25">Up to post</th>
        <th class="fix-w-7p5">% of deals</th>
        <th class="fix-w-7p5">Avg. round</th>
        <th class="fix-w-7p5">Avg. post</th>
        <th class="fix-w-7p5">Dilution, %</th>
        <th class="fix-w-100pcnt"></th>
      </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of data">
      <td>{{ row.upToPost }}</td>
      <td>{{ row.dealsPcnt | switcherDashBraces : 1 : 1: false : '' : '%'}}</td>
      <td>{{ row.avgRound | switcherDashBraces : 1 : 0}}</td>
      <td>{{ row.avgPost | switcherDashBraces : 1 : 0}}</td>
      <td>{{ row.dilution | switcherDashBraces : 1 : 1: false : '' : '%'}}</td>
      <td></td>
    </tr>
    </tbody>
  </table>
</div>
